import { PROPERTY_MANAGER } from '../components/search-filter-bar/enums';

/**
 * Whether an agentFilter from the URL is asking for property managers.
 * agentFilter is user supplied, so anything unrecognised (legacy or hand
 * edited values) falls back to sales agents, matching the filter the UI
 * shows as selected.
 */
const isPropertyManagerFilter = (agentFilter?: string): boolean =>
  agentFilter === PROPERTY_MANAGER || agentFilter === 'rent';

export default isPropertyManagerFilter;
